import { render, staticRenderFns } from "./ModalContentVotingInfo.vue?vue&type=template&id=2e5f8e04&scoped=true&"
import script from "./ModalContentVotingInfo.vue?vue&type=script&lang=js&"
export * from "./ModalContentVotingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f8e04",
  null
  
)

export default component.exports